import React, { Fragment } from "react";
import Languages from "./Main components/Languages";
import Projects from "./Main components/Projects";

const Main = () => {
  return (
    <Fragment>
      <Languages />
      <Projects />
    </Fragment>
  );
};

export default Main;
